<template>
  <el-form ref="ref_gradeAgeMonthForm" :model="gradeAgeMonthForm" :rules="gradeAgeMonthRules" label-width="140px">
    <el-form-item label="推荐年级" prop="gradeCode">
      <el-select v-model="gradeAgeMonthForm.gradeCode" @change="changeGradeAgeMonth" placeholder="请选择推荐年级" clearable style="width: 100%;">
        <el-option
          v-for="item in gradeOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="最小月龄范围" prop="minBabyAge">
      <el-select v-model="gradeAgeMonthForm.minBabyAge" placeholder="请选择" clearable style="margin-right: 20px;">
        <el-option
          v-for="item in babyAgeOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
      <el-select v-model="gradeAgeMonthForm.minBabyMonth" placeholder="请选择" clearable>
        <el-option
          v-for="item in babyMonthOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="最大月龄范围" prop="maxBabyAge">
      <el-select v-model="gradeAgeMonthForm.maxBabyAge" placeholder="请选择" clearable style="margin-right: 20px;">
        <el-option
          v-for="item in babyAgeOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
      <el-select v-model="gradeAgeMonthForm.maxBabyMonth" placeholder="请选择" clearable>
        <el-option
          v-for="item in babyMonthOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import { getDictoryInfoByCode } from '@api/api_common'
import { queryGradeAgeMonth } from '@api/classManagement/api_classManagement'
export default {
  name: 'AgeMonthPage',
  props: {
    gradeAgeMonthForm: {
      type: Object,
      default: () => {

      }
    },
    timestamp: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      gradeOptions:[],
      babyAgeOptions:[],
      babyMonthOptions:[],
      GradeAgeMonthOptions:[],
      gradeAgeMonthRules: {
        gradeCode: [{ required: true, message: '请选择推荐年级', trigger: 'blur' }],
        minBabyAge: [{ required: true, message: '请输入最小月龄范围', trigger: 'blur' }],
        maxBabyAge: [{ required: true, message: '请输入最大月龄范围', trigger: 'blur' }],
      }
    }
  },
  beforeDestroy() {
    this.$refs.ref_textBookForm.resetFields()
  },
   created () {
    getDictoryInfoByCode('GRADE_TYPE').then(res => { this.gradeOptions = res })
    getDictoryInfoByCode('BABY_AGE').then(res => { this.babyAgeOptions = res })
    getDictoryInfoByCode('BABY_MONTH').then(res => { this.babyMonthOptions = res })
    queryGradeAgeMonth().then(res => { this.GradeAgeMonthOptions = res })
  },
  methods: {
    changeGradeAgeMonth(val){
        const selectedOption = this.GradeAgeMonthOptions.find(
            (item) => item.gradeCode === val
        );
        this.gradeAgeMonthForm.id = selectedOption.id
        this.gradeAgeMonthForm.minBabyAge = selectedOption.minBabyAge
        this.gradeAgeMonthForm.minBabyMonth = selectedOption.minBabyMonth
        this.gradeAgeMonthForm.maxBabyAge = selectedOption.maxBabyAge
        this.gradeAgeMonthForm.maxBabyMonth = selectedOption.maxBabyMonth
    }
  }
}
</script>
<style>
</style>
